import { render, staticRenderFns } from "./scanPickUpOrder.vue?vue&type=template&id=628a5d3a&scoped=true&"
import script from "./scanPickUpOrder.vue?vue&type=script&lang=js&"
export * from "./scanPickUpOrder.vue?vue&type=script&lang=js&"
import style0 from "./scanPickUpOrder.vue?vue&type=style&index=0&id=628a5d3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628a5d3a",
  null
  
)

export default component.exports